export const ja = {
  // JSCC24
  day1: "9月18日 (水)",
  day2: "9月19日 (木)",
  day3: "9月20日 (金)",
  msg1: "予稿集は以下のリンクより入手できます。PDFファイルのパスワードは abst74jscc です。",
  venue: "岐阜大学",
  venue_url: "https://www1.gifu-u.ac.jp/~sakuto74/",
  awardvenue: "⻑良川国際会議場メインホール",
  awardvenue_url: "https://www.g-ncc.jp/access/",
  banquetvenue: "都ホテル岐阜長良川",
  banquetvenue_url: "https://www.miyakohotels.ne.jp/gifu/",
  hcvenue: "⻑良川国際会議場 国際会議室",
  hcvenue_url: "https://www.g-ncc.jp/access/",
  luncheonvenue: "全共105教室",
  layout: "配置図",
  JSCCAS: "錯体化学会 第74回討論会",
  // COMMON
  hint1: "発表番号、題目、キーワード、研究場所、発表者名にて検索が可能です.",
  hint2: "正規表現が使えます.",
  hint3: "画像クリックでPDFが開きます.",
  hint4:
    "表示は申込データに基づいており、表示のタイトルおよび著者の一部が要旨とは異なる場合があります.",
  hint5:
    "興味のある講演番号を押すと、下の表に青い印が付きます. 聴講スケジュールを決めるのにご活用下さい.",
  usingjs: "注意: この検索機能は JavaScript を使用しています.",
  "Lunch Break": "昼食",
  "Morning sessions": "午前の部",
  "Afternoon sessions": "午後の部",
  "Poster sessions": "ポスター",
  "Oral sessions": "口頭発表",
  "Award lectures": "受賞講演",
  Banquet: "懇親会",
  "JSCC General Meeting": "錯体化学会総会",
  Supporters: "協賛企業",
  "General Information": "ご案内",
  "Overall schedule": "日程",
  SEARCH: "検索",
  "JSCC Award": "学会賞 受賞講演",
  "JSCC International Award": "国際賞 受賞講演",
  "JSCC Award for Creative Work": "学術賞 受賞講演",
  "JSCC Contribution Award": "貢献賞 受賞講演",
  "JSCC Research Encouragement Award": "研究奨励賞",
  "JSCC International Award for Creative Work": "国際奨励賞 受賞講演",
  "Homecoming Day": "錯体化学ホームカミングデー",
  "Luncheon seminars": "ランチョンセミナー",
  Symposia: "シンポジウム",
  msg2: "懇親会にご参加される方は、以下のリンクより座席をご予約ねがいます。ユーザ名・パスワードはこのサイトと同じです。ひさびさに顔をあわせるご友人とお連れあわせいただき、心ゆくまでご歓談いただければと思います。",
  Announcements: "お知らせ",
  "Seat reservation for the banquet": "懇親会の座席予約",
  "Award lectures": "受賞講演",
  "(In preparation.)": "(準備中)",
  "Abstract book": "講演要旨集",
  "Program book": "討論会プログラム集",
  "(lightweight)": "(軽量版)",
  "Opening Remark": "開会",
  "Closing Remark": "閉会",
  Explanation: "解説",
};
